// src/services/api.js
import axios from 'axios';

const BASE = process.env.VUE_APP_API_URL || 'https://autostalliondetailing-backend.onrender.com/api';

const api = axios.create({
  baseURL: BASE,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// ---------- Auth ----------
export async function loginUser(email, password) {
  const res = await api.post('/auth/login', { email, password });
  return res.data;
}

export async function registerUser(payload) {
  const res = await api.post('/auth/register', payload);
  return res.data;
}

export async function forgotPassword(email) {
  const res = await api.post('/auth/forgot-password', { email });
  return res.data;
}

export async function resetPassword(token, password) {
  const res = await api.post('/auth/reset-password', { token, password });
  return res.data;
}

export async function getCurrentUser() {
  const res = await api.get('/auth/me');
  return res.data;
}

// ---------- Bookings ----------
export async function createBooking(payload) {
  const res = await api.post('/bookings', payload);
  return res.data;
}

// ✅ Added missing ones your frontend needs:
export async function getBookings() {
  const res = await api.get('/bookings');
  return res.data;
}

export async function getPackages() {
  const res = await api.get('/packages');
  return res.data;
}

export async function updateBooking(id, bookingData) {
  const res = await api.put(`/bookings/${id}`, bookingData);
  return res.data;
}

export async function updateBookingStatus(id, status) {
  const res = await api.patch(`/bookings/${id}/status`, { status });
  return res.data;
}

// ---------- Stripe / Checkout ----------
export async function createCheckoutSession({ priceId, quantity = 1, successUrl, cancelUrl }) {
  const res = await api.post('/checkout/create-checkout-session', {
    priceId,
    quantity,
    successUrl,
    cancelUrl,
  });
  return res.data;
}

export default api;
